import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { ChatMessage } from '../services/chatService';
import NereusAvatar from './NereusAvatar';
import MarkdownText from './MarkdownText';

interface Props {
  message: ChatMessage;
  compact?: boolean;
}

const ChatBubble: React.FC<Props> = ({ message, compact }) => {
  const isUser = message.role === 'user';
  const py = compact ? 0.75 : 1.25;
  const px = compact ? 1.25 : 1.75;
  const fontSize = compact ? '0.8rem' : '0.9rem';

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: isUser ? 'flex-end' : 'flex-start',
        mb: compact ? 0.75 : 1.25,
      }}
    >
      {isUser ? (
        <Box
          sx={{
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            borderRadius: 2,
            py,
            px,
            maxWidth: '80%',
          }}
        >
          <Typography sx={{ fontSize, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {message.content}
          </Typography>
        </Box>
      ) : (
        <Box sx={{ display: 'flex', gap: 0.75, maxWidth: '85%' }}>
          <Box sx={{ mt: 0.25 }}>
            <NereusAvatar size={compact ? 22 : 28} />
          </Box>
          <Paper
            elevation={1}
            sx={{
              borderRadius: 2,
              py,
              px,
            }}
          >
            <MarkdownText content={message.content} fontSize={fontSize} />
          </Paper>
        </Box>
      )}
    </Box>
  );
};

export default ChatBubble;
